import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 40 40' fill='none' aria-hidden='true' className={cn('size-9 shrink-0', className)}>
            <path d='M9 35V18a11 11 0 0 1 22 0v17' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' />
            <path d='M13.5 35V19.5a6.5 6.5 0 0 1 13 0V35' stroke='currentColor' strokeWidth='1' strokeLinecap='round' opacity='0.45' />
            <path d='M5 35h30' stroke='currentColor' strokeWidth='1.75' strokeLinecap='round' />
            <circle cx='20' cy='4.5' r='1.5' className='fill-marigold' />
            <g className='fill-marigold'>
                <circle cx='23' cy='22' r='1.9' />
                <circle cx='22.12' cy='24.12' r='1.9' />
                <circle cx='20' cy='25' r='1.9' />
                <circle cx='17.88' cy='24.12' r='1.9' />
                <circle cx='17' cy='22' r='1.9' />
                <circle cx='17.88' cy='19.88' r='1.9' />
                <circle cx='20' cy='19' r='1.9' />
                <circle cx='22.12' cy='19.88' r='1.9' />
            </g>
            <circle cx='20' cy='22' r='1.6' fill='#c26a06' />
        </svg>
    )
}

interface LogoProps {
    tone?: 'dark' | 'light'
    className?: string
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    const isDark = tone === 'dark'

    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name} home`}
            className={cn('inline-flex items-center gap-2.5 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring', className)}
        >
            <LogoMark className={isDark ? 'text-primary' : 'text-gold-light'} />

            <span className='flex flex-col leading-none'>
                <span className={cn('font-heading text-[1.6rem] font-semibold tracking-tight', isDark ? 'text-foreground' : 'text-ivory')}>
                    {siteConfig.name}
                </span>

                <span className={cn('mt-1 text-[0.625rem] font-medium uppercase tracking-[0.3em]', isDark ? 'text-muted-foreground' : 'text-ivory/70')}>
                    Wedding planners
                </span>
            </span>
        </Link>
    )
}
